import Controller, { OnBeforeSubmit, OnCancel, OnClick, OnClose, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import BaseController from '../../../../BaseController';
import { ComfortBScaleAliases, FragmentNames } from '../../../../../codegen';
import { Inject } from '@odinjs/odin';
import { FormAPI, ModalService, PanelAPI, RadioGroupAPI, SelectableItem } from '@philips-internal/oswald-ui-components';
import { MountEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { Endpoint } from '../../../../../constants/endpoints';

@Controller({ component: ComfortBScaleAliases.COMFORT_B_SCALE_LAYOUT, fragment: FragmentNames.COMFORT_B_SCALE })
export default class ComfortBScaleController extends BaseController {

  @Inject(ComfortBScaleAliases.LEVEL_OF_CONSCIOUSNESS_RG)
  private levelOfConsciousnessRadioGroupApi!: RadioGroupAPI;

  @Inject(ComfortBScaleAliases.CALM_AGITATION_RG)
  private calmAgitationRadioGroupApi!: RadioGroupAPI;

  @Inject(ComfortBScaleAliases.RESPIRATORY_RESPONSE_RG)
  private respiratoryResponseRadioGroupApi!: RadioGroupAPI;

  @Inject(ComfortBScaleAliases.CRY_RG)
  private cryRadioGroupApi!: RadioGroupAPI;

  @Inject(ComfortBScaleAliases.PHYSICAL_MOVEMENT_RG)
  private physicalMovementRadioGroupApi!: RadioGroupAPI;

  @Inject(ComfortBScaleAliases.MUSCLE_TONE_RG)
  private muscleToneRadioGroupApi!: RadioGroupAPI;

  @Inject(ComfortBScaleAliases.FACIAL_TENSION_RG)
  private facialTensionRadioGroupApi!: RadioGroupAPI;

  @Inject(ComfortBScaleAliases.COMFORT_B_SCALE_PANEL)
  private referencePanelWithModalApi!: PanelAPI;

  @Inject(ComfortBScaleAliases.LEVEL_OF_CONSCIOUSNESS_FORM)
  private levelOfConsciousnessFormApi!: FormAPI;

  @OnMount(ComfortBScaleAliases.LEVEL_OF_CONSCIOUSNESS_RG)
  handleMountLevelOfConciousnessRedioGroup(event: MountEvent): void {
    this.fetchComfortBScale(748241, event.target as RadioGroupAPI);
  }

  @OnMount(ComfortBScaleAliases.CALM_AGITATION_RG)
  handleMountCalmAgitationRadioGroup(event: MountEvent): void {
    this.fetchComfortBScale(748245, event.target as RadioGroupAPI);
  }

  @OnMount(ComfortBScaleAliases.RESPIRATORY_RESPONSE_RG)
  handleMountRespiratoryResponseRadioGroup(event: MountEvent): void {
    this.fetchComfortBScale(335951, event.target as RadioGroupAPI);
  }

  @OnMount(ComfortBScaleAliases.CRY_RG)
  handleMountCryRadioGroup(event: MountEvent): void {
    this.fetchComfortBScale(335952, event.target as RadioGroupAPI);
  }

  @OnMount(ComfortBScaleAliases.PHYSICAL_MOVEMENT_RG)
  handleMountPhysicalMovementRadioGroup(event: MountEvent): void {
    this.fetchComfortBScale(335953, event.target as RadioGroupAPI);
  }

  @OnMount(ComfortBScaleAliases.MUSCLE_TONE_RG)
  handleMountMuscleToneRadioGroup(event: MountEvent): void {
    this.fetchComfortBScale(335954, event.target as RadioGroupAPI);
  }

  @OnMount(ComfortBScaleAliases.FACIAL_TENSION_RG)
  handleMountFacialTensionRadioGroup(event: MountEvent): void {
    this.fetchComfortBScale(335948, event.target as RadioGroupAPI);
  }

  @OnClick(ComfortBScaleAliases.COMFORT_B_SCALE_REFERENCE_LINK)
  onClickReference(): void {
    this.referencePanelWithModalApi.setVisible(true);
  }

  @OnClose(ComfortBScaleAliases.MODAL_PAIN_SCALE_REFERENCE)
  onCloseModalReference(): void {
    this.referencePanelWithModalApi.setVisible(false);
  }

  @OnCancel(ComfortBScaleAliases.LEVEL_OF_CONSCIOUSNESS_FORM)
  onClickCancel(): void {
    ModalService.close(FragmentNames.COMFORT_B_SCALE);
  }

  @OnBeforeSubmit(ComfortBScaleAliases.LEVEL_OF_CONSCIOUSNESS_FORM)
  onBeforeSubmitForm(): void {
    const setValue = this.context.get('setValue');
    setValue(Number(this.levelOfConsciousnessRadioGroupApi.getValue()?.value)
          + Number(this.calmAgitationRadioGroupApi.getValue()?.value)
          + Number(this.respiratoryResponseRadioGroupApi.getValue()?.value)
          + Number(this.cryRadioGroupApi.getValue()?.value)
          + Number(this.muscleToneRadioGroupApi.getValue()?.value)
          + Number(this.physicalMovementRadioGroupApi.getValue()?.value)
          + Number(this.facialTensionRadioGroupApi.getValue()?.value));

    ModalService.close(FragmentNames.COMFORT_B_SCALE);
  }

  fetchComfortBScale(expressionId: number, radioGroup: RadioGroupAPI): void {
    const { encounterId, patientId } = this.historyService.getCurrentRouteParams();
    this.levelOfConsciousnessFormApi.setDisabled(true)
    HttpService.get(Endpoint.GET_PAIN_SCALE_DATA, { encounterId, expressionId, patientId })
      .then(response => {
        if(response) {
          const responseBody = response.body as SelectableItem[];
          radioGroup.setData(responseBody);
          radioGroup.setValue(responseBody[0]);
        }
      }).finally(() => {
        this.levelOfConsciousnessFormApi.setDisabled(false)
      });
  }
}